import { Trans, useTranslation } from '@clofo/i18n'
import { Alert, AlertDescription } from '@clofo/ui/alert'
import { Badge } from '@clofo/ui/badge'
import { Button } from '@clofo/ui/button'
import { IceIcon } from '@clofo/ui/ice-icon'
import { useLocalStorageState } from '@clofo/ui/hooks'

const HELP_CENTER_URL =
  'https://help.closingfolders.com/hc/en-us/articles/55242988481427-Sign-in-with-an-iManage-account'

/** Dismissible notice advertising Login with Work (signing in with a Cloud iManage account). */
export const CimNotice = () => {
  const { t } = useTranslation()
  const [isDismissed, setIsDismissed] = useLocalStorageState('cf-cim-notice-dismissed', false)

  if (isDismissed) return null

  return (
    <Alert variant='info' role='note' data-slot='cim-notice' className='mt-6 border border-primary'>
      <Badge variant='primary' className='absolute -top-2.5 left-4 uppercase font-bold'>
        {t('login.cimNoticeBadge')}
      </Badge>
      <IceIcon name='imanage-bug' className='text-2xl text-primary' />
      <AlertDescription className='flex items-start justify-between gap-2'>
        <p>
          <Trans
            t={t}
            i18nKey='login.cimNotice'
            components={{
              helpLink: (
                <a
                  className='text-primary font-medium hover:underline'
                  href={HELP_CENTER_URL}
                  target='_blank'
                  rel='noopener noreferrer'
                />
              ),
            }}
          />
        </p>
        <Button
          type='button'
          variant='link'
          size='sm'
          onClick={() => setIsDismissed(true)}
          aria-label={t('login.dismissCimNotice')}
          className='h-auto p-0 shrink-0 text-foreground hover:no-underline'
        >
          <IceIcon name='close-delete-x' />
        </Button>
      </AlertDescription>
    </Alert>
  )
}
